import { render, staticRenderFns } from "./ConfirmUnlinkDialog.vue?vue&type=template&id=37efc34d"
import script from "./ConfirmUnlinkDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmUnlinkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports